import { Grid } from "@mui/material";
import { useTools } from "../../app/hooks";
import Error from "../common/Error";
import Loading from "../common/Loading";
import ToolCard from "./ToolCard";

export default function Tools() {
  const { tools, loading, error } = useTools();

  if (loading) return <Loading />;

  if (error) return <Error error={error} />;

  return (
    <Grid container spacing={4} justifyContent="center">
      {tools.map((tool, i) => (
        <Grid key={i} size="auto">
          <ToolCard toolConfig={tool} />
        </Grid>
      ))}
    </Grid>
  );
}
